module.exports = __webpack_public_path__ + "resources/img/img_codesign2_m_en.0a2b2c0fe99154d45188a17dede8a42e.png";